<template>
    <div class='empty-space' :style='[element.element_config.compiled_styles, custom_styles.container]' :class='[classes.container]'>
        <div v-if='page_builder_mode' class='empty-space-text'>
            <div v-show='element.layers.length == 0'>Empty space</div>
        </div>
    </div>
</template>

<script>
import format_custom_styles from "@/page_builder/builder/builder_tools/functions/format_custom_styles.js";

export default {
    components: {},
    props:['element', 'page_builder_mode'],
    mixins: [format_custom_styles],
    data(){
        return{
            styles:{},
            classes: {}
        }
    },
    methods:{
        setStyles(){
            this.setCustomCssStyles(this.element.element_config.custom_styles); //From mixin
            
            if(this.element.element_config.compiled_classes != null){
                this.classes = this.element.element_config.compiled_classes;
            }
        }
    },
    watch:{
       'element': {
            handler(){
                this.setStyles();
                this.setCustomCssStyles(this.element.element_config.custom_styles); //From mixin
            },
            deep: true
        }
    },
    mounted(){
        this.setStyles();
    }

}
</script>

<style lang="scss" scoped>
.empty-space{
    width: 100%;
}

.empty-space-text{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-size: 1rem;
    color: #385170;
    height: 100%;
    opacity: 0.4;
}
</style>